<template>
  <div>
    <vx-card title="Услуга" class="p-6 mb-5">
      <div v-if="paidService" class="vx-row">
        <div class="vx-col flex-1">
          <table>
            <tr>
              <td class="font-semibold">Название услуги</td>
              <td class="pl-4">
                <span class="text-primary">{{ paidService.name }}</span>
              </td>
            </tr>
            <tr>
              <td class="font-semibold">Дата создания услуги</td>
              <td class="pl-4">
                <span class="text-primary">{{ paidService.date_created }}</span>
              </td>
            </tr>
            <tr>
              <td class="font-semibold">Оплатить до</td>
              <td class="pl-4">
                <span class="text-primary">{{ paidService.date_pay_to }}</span>
              </td>
            </tr>
            <tr>
              <td class="font-semibold">Сумма</td>
              <td class="pl-4">
                <span class="text-primary">{{ paidService.amount }} руб.</span>
              </td>
            </tr>

            <tr>
              <td class="font-semibold">Оплачен</td>
              <td class="pl-4">
                <span
                  class="font-semibold"
                  :class="{
                    'text-success': paidService.is_paid,
                    'text-danger': !paidService.is_paid,
                  }"
                  >{{ paidService.is_paid ? "Да" : "Нет" }}</span
                >
              </td>
            </tr>
            <tr v-if="paidService.comment">
              <td class="font-semibold">Примечание</td>
              <td class="pl-4">
                <span class="text-primary">{{ paidService.comment }}</span>
              </td>
            </tr>
          </table>
        </div>
      </div>
      <template slot="footer">
        <vs-button
          @click="popupEditService = true"
          class="mr-3"
          color="success"
        >
          Изменить
        </vs-button>
        <vs-button @click="popupDeleteComfirm = true" color="danger">
          Удалить
        </vs-button>
      </template>
    </vx-card>

    <vx-card title="Счета" class="p-6 h-full">
      <vs-list v-if="paidService.invoice">
        <vs-list-item
          :title="`Номер: #${paidService.invoice.id}. Сумма: ${paidService.invoice.price} руб`"
          :subtitle="`Оплачен: ${paidService.invoice.is_paid ? 'Да' : 'Нет'}`"
        >
          <vx-tooltip class="inline-block" text="Открыть">
            <vs-button
              :href="`/communal-payments/bills/${paidService.invoice.id}`"
              icon-pack="feather"
              icon="icon-external-link"
              color="danger"
              size="small"
            ></vs-button>
          </vx-tooltip>
        </vs-list-item>
      </vs-list>
      <p v-else>Счета отсутствуют</p>
    </vx-card>

    <vs-popup
      v-if="paidService"
      title="Редактирование услуги"
      :active.sync="popupEditService"
    >
      <vs-input
        class="w-full mb-4"
        label="Название"
        name="Название"
        v-model="paidService.name"
      />

      <vs-input
        class="w-full mb-4"
        label="Сумма"
        name="Сумма"
        type="number"
        v-model.number="paidService.amount"
      />

      <vs-input
        class="w-full mb-4"
        label="Примечание"
        name="Примечание"
        v-model="paidService.comment"
      />

      <label class="vs-input--label">Оплатить до</label>
      <flat-pickr
        class="block w-full"
        :config="configdateTimePickerFilter"
        v-model="paidService.date_pay_to"
        placeholder="Оплатить до"
      />

      <div class="popup-footer mt-4">
        <vs-button
          @click="updateService"
          class="mr-5"
          type="relief"
          color="success"
          >Обновить</vs-button
        >
      </div>
    </vs-popup>

    <vs-popup
      v-if="paidService"
      title="Вы действительно хотите удалить?"
      :active.sync="popupDeleteComfirm"
    >
      <p class="font-semibold mb-5">
        Услуга #<span class="text-danger text-lg">{{ paidService.id }}</span>
        будет удалена безвозвратно
      </p>
      <vs-button
        @click="deleteService"
        color="danger"
        class="mr-5"
        type="filled"
        >Удалить</vs-button
      >
      <vs-button @click="popupDeleteComfirm = false" color="dark" type="border"
        >Отмена</vs-button
      >
    </vs-popup>
  </div>
</template>
<script>
import { API_URL } from "@/.env";
import { DateTime } from "luxon";

import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { Russian as RussianLocale } from "flatpickr/dist/l10n/ru.js";

export default {
  data: () => ({
    BASE_URL: API_URL,

    paidService: null,
    popupDeleteComfirm: false,
    popupEditService: false,

    configdateTimePickerFilter: {
      enableTime: false,
      dateFormat: "d.m.Y",
      noCalendar: false,
      locale: RussianLocale,
    },
  }),
  components: {
    DateTime,
    flatPickr,
  },
  watch: {},
  computed: {},
  methods: {
    notification(title, message, color) {
      this.$vs.notify({
        title: title,
        text: message,
        color: color,
        position: "top-center",
        time: "4000",
        icon: "delete",
      });
    },
    getPaidService() {
      this.$load(async () => {
        let res = (
          await this.$api.paidServices.getService(this.$route.params.id)
        ).data;

        res.date_created = DateTime.fromISO(res.date_created).toFormat(
          "dd.MM.yyyy"
        );

        res.date_pay_to = DateTime.fromFormat(
          res.date_pay_to,
          "yyyy-MM-dd"
        ).toFormat("dd.MM.yyyy");

        this.paidService = res;
      });
    },
    deleteService() {
      this.$load(async () => {
        await this.$api.paidServices
          .deleteService(this.$route.params.id)
          .then((response) => {
            if (response.status == 200) {
              this.popupDeleteComfirm = false;
              this.notification("Успешно", "Услуга удалена", "success");
              this.$router.push({ name: "paid-services" });
            } else {
              this.notification(
                "Ошибка",
                "Не удалось удалить услугу",
                "danger"
              );
            }
          });
      });
    },
    updateService() {
      let payload = {
        name: this.paidService.name,
        amount: this.paidService.amount,
        date_pay_to: DateTime.fromFormat(
          this.paidService.date_pay_to,
          "dd.MM.yyyy"
        ).toFormat("yyyy-MM-dd"),
        comment: this.paidService.comment,
      };

      this.$load(async () => {
        await this.$api.paidServices
          .updateService(this.paidService.id, payload)
          .then((response) => {
            this.notification("Успешно", "Услуга обновлена", "success");
          })
          .catch((error) => {
            this.notification("Ошибка", "Не удалось обновить услугу", "danger");
          });
      });

      this.popupEditService = false;
    },
  },
  mounted() {
    this.getPaidService();
  },
};
</script>